let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("55DIU")).then(() => parcelRequire('9BixH'));